/*
 * Vehicle related services
 *
 * @author lachezar.parvin
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2021 Gallagher Bassett Services, Inc.
 */

import { Injectable } from '@angular/core';
import { Constants } from 'app/shared/config/constants';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  VehicleHistoricalLocationsResponse,
  VehiclesResponse,
  VehicleType
} from 'app/shared/models';
import { UserService } from 'app/shared/services/user.service';

@Injectable ( {
  providedIn: 'root'
} )
export class VehicleService {
  readonly url = Constants.vehiclesUrl;
  readonly historicalLocationsUrl = Constants.vehicleHistoricalLocationsUrl;
  readonly pageSize = 50;

  constructor( private http: HttpClient, private userService: UserService ) {
  }

  search( criteria: any, pageNumber = 1, pageSize = this.pageSize ): Observable<VehiclesResponse> {
    const clientNumber = this.userService.currentClient?.clientNumber;
    const params = new HttpParams ().appendAll ( {
      includeDescendants: true, ...criteria,
      pageNumber,
      pageSize,
      clientNumber,
    } );
    return this.http.get<VehiclesResponse> ( this.url, { params } );
  }

  getHistoricalLocations ( vehicleId: string ): Observable<VehicleHistoricalLocationsResponse> {
    return this.http.get<VehicleHistoricalLocationsResponse> ( this.historicalLocationsUrl.replace ( '{vehicleId}', vehicleId ) );
  }
}
